import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ProductListState, { ProductPageFilters } from "@store/Store/Pages/ProductList/ProductListState";
import { Draft } from "immer";

const initialState: ProductListState = {
    productPageFilters: {},
    isMoreLoading: false,
    scrollData: undefined,
    pageUrl: undefined,
    pageFilterQuery: undefined,
};

const reducer = {
    "Store/Pages/ProductList/SetProductPageFilters": (
        draft: Draft<ProductListState>,
        action: { result: ProductPageFilters },
    ) => {
        draft.productPageFilters = action.result;
    },
    "Store/Pages/ProductList/SetPageFilterQuery": (draft: Draft<ProductListState>, action: { result: string }) => {
        draft.pageFilterQuery = action.result;
    },
    "Store/Pages/ProductList/BeginLoadMoreProducts": (draft: Draft<ProductListState>) => {
        draft.isMoreLoading = true;
    },
    "Store/Pages/ProductList/CompleteLoadMoreProducts": (draft: Draft<ProductListState>) => {
        draft.isMoreLoading = false;
    },
    "Store/Pages/ProductList/DispatchScrollData": (
        draft: Draft<ProductListState>,
        action: { scrollData: number }
    ) => {
        draft.scrollData = action.scrollData;
    },
    "Store/Pages/ProductList/DispatchCatalogPageUrl": (
        draft: Draft<ProductListState>,
        action: { pageUrl: string, pageFilterQuery: string }
    ) => {
        draft.pageUrl = action.pageUrl;
        draft.pageFilterQuery = action.pageFilterQuery;
    },
    "Store/Pages/ProductList/ClearCatalogPageUrl": (draft: Draft<ProductListState>) => {
        draft.scrollData = undefined;
        draft.pageUrl = undefined;
        draft.pageFilterQuery = undefined;
    },
    "Store/Pages/ProductList/SetIsFilterNavOpen": (draft: Draft<ProductListState>, action: { isOpen?: boolean }) => {
        draft.isFilterNavOpen = action.isOpen;
    },
};

const productListReducer = createTypedReducerWithImmer(initialState, reducer);

export default productListReducer; 
